/**
 * Operators actions
 */

import list from 'GraphQL/queries/operators/list.gql'

import { apollo } from '@/plugins/apollo'

export default {
  async getList ({ state, dispatch, commit, rootState }, payload = false) {
    if (payload) {
      commit('setLoading', true, { root: true })
    }

    await apollo.query({
      query: list,
      variables: {
        apiToken: rootState.users.entity.apiToken,
        language: rootState.language
      },
      fetchPolicy: 'no-cache'
    }).then((response) => {
      const { status, result } = response.data.operators
      // console.log(response)

      switch (status) {
        case 'OK':
          commit('setList', result)
          break
        case 'UNPROCESSABLE':
          commit('toggleSnackbar', undefined, { root: true })
          break
      }
    }).catch((error) => {
      console.error('Customers Actions Error: ', error)
      commit('toggleSnackbar', undefined, { root: true })
    }).finally(() => {
      if (payload) {
        commit('setLoading', false, { root: true })
      }
    })
  }
}